import { VueConstructor } from 'vue';

export default {
  install: (Vue: VueConstructor, options: any) => {
    Vue.directive('click-outside', {
      bind(el, binding, vnode) {
        // Add it to the element, for ease of access
        (el as any).$clickOutsideEvent = (event: MouseEvent) => {
          // Check that click was outside the el and its children
          if (!(el === event.target || el.contains(event.target as Node))) {
            // and if it did, call method provided in attribute value
            binding.value(event);
          }
        };
        document.body.addEventListener('click', (el as any).$clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', (el as any).$clickOutsideEvent);
        delete (el as any).$clickOutsideEvent;
      },
    });
  },

};
